import RoleTab from '@UI/Pages/Administration/Roles/RoleTabs/RoleTab';
import type RoleView from '@UI/Store/Roles/Views/RoleView';
import { css } from '@emotion/react';
import type * as React from 'react';

const tabsRowStyle = css`
	display: flex;
	gap: 0.5rem;
	flex-wrap: wrap;
`;

type Props = {
	readonly roles: readonly RoleView[];
	readonly selectedRoleId: number | null;
};

/** One pill per role, `{label} · {assignedUserCount}` — the organization's whole role set, unpaginated. */
const RoleTabs: React.FC<Props> = ({ roles, selectedRoleId }) => {
	return (
		<div css={tabsRowStyle}>
			{roles.map((role) => (
				<RoleTab key={role.id} role={role} isSelected={role.id === selectedRoleId} />
			))}
		</div>
	);
};

export default RoleTabs;
